import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = { id_estoque_local: 2 }) {
    return {
        type: 'ACESSORIO_SAIDA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'ACESSORIO_SAIDA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function setFiltro(filtro) {
    return {
        type: 'ACESSORIO_SAIDA_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function initForm(registro = { id_estoque_local: 2 }) {
    return [
        initialize('acessorioSaidaForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
		dispatch(setAguardando(true));
    	axios.get(`${consts.API_URL}/acessorioSaida?id_cliente=${getState().auth.usuario.id_cliente || 0}
				&data_inicial=${DateFormat.formatarDataTelaParaSql(getState().acessorioSaida.filtro.data_inicial) == 'Invalid DateTime' ? null : DateFormat.formatarDataTelaParaSql(getState().acessorioSaida.filtro.data_inicial)}
				&data_final=${DateFormat.formatarDataTelaParaSql(getState().acessorioSaida.filtro.data_final) == 'Invalid DateTime' ? null : DateFormat.formatarDataTelaParaSql(getState().acessorioSaida.filtro.data_final)}`)
		.then(resp => {
			dispatch({
		        type: 'ACESSORIO_SAIDA_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvar(registro) {
		
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/acessorioSaida`, {
				...registro,
				id_cliente: getState().auth.usuario.id_cliente,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id,
				datahora_saida: DateFormat.getDataHoraAtual(),
				quantidade: String(registro.quantidade || '').replace(',', '.'),
				minimo: 0,
				maximo: 0,
				web: true
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/acessorioSaida`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id,
				datahora_saida: DateFormat.formatarDataHoraTelaParaSql(registro.datahora_saida),
				quantidade: String(registro.quantidade || '').replace(',', '.'),
				minimo: 0,
				maximo: 0,
				web: true
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/acessorioSaida?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaTipo() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/acessorioTipo/listarSelect`)
		.then(resp => {
			dispatch({
				type: 'ACESSORIO_SAIDA_TIPO_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaEvento() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/acessorioEvento/listarSelect`)
		.then(resp => {
			dispatch({
				type: 'ACESSORIO_SAIDA_EVENTO_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaUnidade() {
    const request = axios.get(`${consts.API_URL}/unidade/listarSelect`);
    return {
        type: 'ACESSORIO_SAIDA_UNIDADE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaVeiculo() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/veiculo/listarSelect`)
		.then(resp => {
			dispatch({
				type: 'ACESSORIO_SAIDA_VEICULO_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaMotorista() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/motorista/listarSelect`)
		.then(resp => {
			dispatch({
				type: 'ACESSORIO_SAIDA_MOTORISTA_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}


export function gerarFormulario(registro) {

	return (dispatch, getState) => {

		axios.post(`${consts.API_URL}/acessorioSaida/formulario`, registro)
		.then(resp => {
			window.open(`https://api-letsarapremiacao.infinitum-ti.com/${resp.data}`, '_blank');
		}).catch(ex => {
			console.log(ex);
		});

	}
}